import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63efd763"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agent-checkout" }
const _hoisted_2 = { class: "col--12" }
const _hoisted_3 = {
  key: 0,
  class: "close"
}
const _hoisted_4 = {
  key: 1,
  class: "open"
}
const _hoisted_5 = { class: "grand-total col--12" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "button-container col--12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingHeader = _resolveComponent("BookingHeader")!
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BookingBasket = _resolveComponent("BookingBasket")!
  const _component_BaseExpansion = _resolveComponent("BaseExpansion")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BookingHeader, {
      title: _ctx.$t('checkout.agentTitle'),
      subtitle: _ctx.$t('checkout.agentSubtitle')
    }, null, 8, ["title", "subtitle"]),
    _createVNode(_component_BaseSection, { class: "row" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            class: _normalizeClass(["toggle", {'opened': _ctx.showBasket}]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleBasket && _ctx.toggleBasket(...args)))
          }, [
            (_ctx.showBasket)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('payment.hideDetails')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('payment.showDetails')), 1)),
            _createVNode(_component_BaseSvg, { icon: 'chevron/chevron-dropdown-down' })
          ], 2),
          _createVNode(_component_BaseExpansion, {
            expanded: _ctx.showBasket,
            class: "basket-container"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BookingBasket, { renderBasketContainer: false })
            ]),
            _: 1
          }, 8, ["expanded"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('payment.grandTotal')), 1),
          (_ctx.bookingSummary.totalPrice > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.bookingSummary.currency) + " " + _toDisplayString(_ctx.bookingSummary.leftToPay.toFixed(2)), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, "-"))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_BaseButton, {
            loading: _ctx.loadingNextStep,
            onClick: _ctx.nextStep
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("checkout.confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          _createVNode(_component_BaseButton, {
            type: "button",
            onClick: _ctx.prevStep,
            class: "button--white"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("nav.goBack")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}